"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRInvalidateCachePlugin = void 0;
const INVALIDATE_CACHE_HEADER = 'invalidate-cache';
const INVALIDATE_CACHE_HEADER_ENABLED = 'true';
class XHRInvalidateCachePlugin {
    constructor(invalidateCache) {
        this.name = this.constructor.name;
        this.invalidateCache = invalidateCache;
    }
    async handleResponse(response) {
        const { responseHeaders } = response.data;
        const invalidateCacheHeader = responseHeaders[INVALIDATE_CACHE_HEADER];
        if (invalidateCacheHeader === INVALIDATE_CACHE_HEADER_ENABLED) {
            this.invalidateCache();
        }
        return Promise.resolve(response);
    }
}
exports.XHRInvalidateCachePlugin = XHRInvalidateCachePlugin;
//# sourceMappingURL=xhrInvalidateCachePlugin.js.map